import axios from "axios";
import { CN_API_ROOT } from "@/configs";
const http = axios.create({
  baseURL: CN_API_ROOT
});
export default {
  get: http.get,
  post: http.post,
  head: http.head
};
